module.exports = __webpack_public_path__ + "static/media/Project.aacaef74.svg";